module.exports = __webpack_public_path__ + "5c3d3eb8e0edf14c5674012803e7eec6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C000009RM.png
// module id = 1549
// module chunks = 0